import React from 'react'
import { connect } from 'react-redux'
import { addListItem, changeListItem, deleteListItem, getMixedListValues, nullDate, TDate, getListFromValues } from '../../public/utility'
import { hasChangedValues, getFormValue, changeItemsValue } from '../../public/utility/formValues'

class ProcessDetail extends React.Component {
    state = {
        changedValues基本信息: {},
    }

    componentDidMount = () => {
        this.doGetProcessDetail(this.props.id)
    }
    componentWillUnmount = () => {
        this.unmount = true
    }
    doGetProcessDetail = (id) => {
        Tyan.doPostEvent({
            event: 'GetProcessDetail',
            data: { id },
            onEnd: ({ errorMessage, initValues基本信息, optionsParas }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    this.setState({ id, initValues基本信息, changedValues基本信息: {}, optionsParas })
                }
            }
        })
    }

    handlerFlow = (strAction) => {
        const { onSave, onClose } = this.props
        const { id } = this.state
        // Tyan.pubForm.showConfirm('确定要' + strAction,
        //     () => Tyan.doPostEvent({
        //         event: 'Processflow',
        //         data: { id, strAction },
        //         onEnd: ({ id, errorMessage }) => {
        //             if (errorMessage) {
        //                 Tyan.pubForm.showError(errorMessage)
        //             }
        //             else {
        //                 Ext.toast(strAction + '成功')
        //                 onClose && onClose()
        //                 // this.doGetProcess(id)
        //             }
        //         }
        //     })
        // )
    }

    handlerSave = () => {
        // const { dispatch, onSave, onClose } = this.props
        // const { id, changedValues基本信息, initValues基本信息 } = this.state
        // const values = { ...initValues基本信息, ...changedValues基本信息 }
        // Tyan.doPostEvent({
        //     event: 'SaveProcess',
        //     data: { id, changedValues基本信息: values },
        //     onEnd: ({ id, errorMessage }) => {
        //         if (errorMessage) {
        //             Tyan.pubForm.showError(errorMessage)
        //         }
        //         else {
        //             Ext.toast('保存成功')
        //             this.doGetProcess(id)
        //         }
        //     }
        // })
    }

    handlerDelete = () => {
        // const { id } = this.state
        // const { onSave, onClose, dispatch } = this.props

        // Tyan.pubForm.showConfirm('确定要删除？', () =>
        //     Tyan.doPostEvent({
        //         event: 'DeleteProcess',
        //         data: { id },
        //         onEnd: ({ errorMessage }) => {
        //             if (errorMessage) {
        //                 Tyan.pubForm.showError(errorMessage)
        //             }
        //             else {
        //                 Ext.toast('删除成功')
        //                 onSave && onSave()
        //                 onClose && onClose()
        //             }
        //         }
        //     }))
    }

    handlerClose = () => {
        const { onClose } = this.props
        // if (!this.bChanged()) {
        //     onClose && onClose()
        //     return
        // }
        // Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
        onClose && onClose()
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    bSave = () => {
        const { initValues基本信息, changedValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        return Object.keys(changedValues基本信息).length > 0 && values.流程名称
    }

    // handleAddProcessStatus = () => {
    //     const { dispatch, onSave, onClose } = this.props
    //     const { id, changedValues基本信息, initValues基本信息 } = this.state
    //     const values = { ...initValues基本信息, ...changedValues基本信息 }
    //     Tyan.doPostEvent({
    //         event: 'SaveProcess',
    //         data: { id, changedValues基本信息: values },
    //         onEnd: ({ id, errorMessage }) => {
    //             if (errorMessage) {
    //                 Tyan.pubForm.showError(errorMessage)
    //             }
    //             else {
    //                 Tyan.pubForm.showDialog('流程状态设置', props => <ProcessStatusDiv {...props} id={0} ProcessID={id} onRefresh={() => this.doGetProcess(id)} />)
    //             }
    //         }
    //     })
    // }

    // handleAddProcessFormItem = () => {
    //     const { dispatch, onSave, onClose } = this.props
    //     const { id, changedValues基本信息, initValues基本信息 } = this.state
    //     const values = { ...initValues基本信息, ...changedValues基本信息 }
    //     Tyan.doPostEvent({
    //         event: 'SaveProcess',
    //         data: { id, changedValues基本信息: values },
    //         onEnd: ({ id, errorMessage }) => {
    //             if (errorMessage) {
    //                 Tyan.pubForm.showError(errorMessage)
    //             }
    //             else {
    //                 Tyan.pubForm.showDialog('表单项设置', props => <ProcessFormItemDiv {...props} id={0} ProcessID={id} onRefresh={() => this.doGetProcess(id)} />)
    //             }
    //         }
    //     })
    // }

    fieldset基本信息 = () => {
        const { initValues基本信息, changedValues基本信息 } = this.state
        const values = { ...initValues基本信息 }
        // const 表单项 = values.表单项
        // console.log('表单项', 表单项)
        const obj表单项 = getListFromValues('表单项', values['表单项'], initValues基本信息, changedValues基本信息)
        console.log('obj表单项', obj表单项)
        var _fieldset = []
        obj表单项.list.forEach(o => {
            // const _list = { listName: '表单项', id: o.id }
            // const { list: listDetail = [] } = Tyan.utility.getListItems(this, '基本信息', `表单项[${o.id}]`)
            var child = this.showProcessInfo(o)
            if (child)
                _fieldset.push(child)
        });
        console.log('_fieldset', _fieldset)
        return _fieldset
    }

    showProcessInfo = (o) => {
        switch (o.输入方式) {
            case "字符串":
            case "文本输入":
                return {
                    _text: o.显示名称 && o.显示名称 !== "" ? o.显示名称 : o.表单项名称,
                    name: o.表单项名称,
                    required: o.是否必填 && o.是否必填 == "是" ? true : false,
                    minWidth: '45%'
                }
            case "多行文本输入":
                return {
                    _text: o.显示名称 && o.显示名称 !== "" ? o.显示名称 : o.表单项名称,
                    name: o.表单项名称,
                    required: o.是否必填 && o.是否必填 == "是" ? true : false,
                    minWidth: '45%',
                    maxRows: 3
                }
            case "整数":
                return {
                    _int: o.显示名称 && o.显示名称 !== "" ? o.显示名称 : o.表单项名称,
                    name: o.表单项名称,
                    required: o.是否必填 && o.是否必填 == "是" ? true : false,
                    minWidth: '45%'
                }
            case "时间":
                return {
                    _datetime: o.显示名称 && o.显示名称 !== "" ? o.显示名称 : o.表单项名称,
                    name: o.表单项名称,
                    required: o.是否必填 && o.是否必填 == "是" ? true : false,
                    minWidth: '45%'
                }
            case "日期":
                return {
                    _date: o.显示名称 && o.显示名称 !== "" ? o.显示名称 : o.表单项名称,
                    name: o.表单项名称,
                    required: o.是否必填 && o.是否必填 == "是" ? true : false,
                    minWidth: '45%'
                }
            case "下拉选择":
                return {
                    _select: o.显示名称 && o.显示名称 !== "" ? o.显示名称 : o.表单项名称,
                    name: o.表单项名称,
                    required: o.是否必填 && o.是否必填 == "是" ? true : false,
                    minWidth: '45%'
                } 
            case "全部部门选择控件":
            case "部门选择控件":
                return {
                    _treeselect: o.显示名称 && o.显示名称 !== "" ? o.显示名称 : o.表单项名称,
                    name: o.表单项名称,
                    required: o.是否必填 && o.是否必填 == "是" ? true : false,
                    minWidth: '45%',
                    // displayField: '部门名称', options: optionsList,
                    displayFull: '/', displayName: 'fullName', fullNameField: 'fullName', leafOnly: false, rootText: '',
                }
            case "表单组":
            case "列表":
            case "子流程":
                return this.fieldset子表单项(o)
            default:
                return null
        }
    }

    showProcessChildDetail = (o) => {
        switch (o.输入方式) {
            case "字符串":
            case "文本输入":
            case "多行文本输入":
            case "下拉选择":
            case "全部部门选择控件":
            case "部门选择控件":
                return {
                    _text: o.显示名称 && o.显示名称 !== "" ? o.显示名称 : o.表单项名称,
                    name: o.表单项名称,
                    flex: 1,
                }
            case "整数":
                return {
                    _int: o.显示名称 && o.显示名称 !== "" ? o.显示名称 : o.表单项名称,
                    name: o.表单项名称,
                    flex: 1,
                }
            case "时间":
                return {
                    _datetime: o.显示名称 && o.显示名称 !== "" ? o.显示名称 : o.表单项名称,
                    name: o.表单项名称,
                    flex: 1,
                }
            case "日期":
                return {
                    _date: o.显示名称 && o.显示名称 !== "" ? o.显示名称 : o.表单项名称,
                    name: o.表单项名称,
                    flex: 1,
                }
            // case "表单组":
            // case "列表":
            // case "子流程":
            //     return this.fieldset子表单项(o)
            default:
                return null
        }
    }

    fieldset子表单项 = (objInfo) => {
        // const { initValues基本信息, changedValues基本信息 } = this.state
        var _columns = []
        const obj子表单项 = getListFromValues('子表单项', objInfo)
        obj子表单项.list.forEach(o => {
            var child = this.showProcessChildDetail(o)
            if (child)
                _columns.push(child)
        });
        return {
            _grid: objInfo.显示名称 && objInfo.显示名称 !== "" ? objInfo.显示名称 : objInfo.表单项名称, name: '子表单项_' + objInfo.id, rowNumbers: true, minRows: 3, minWidth: '95%', height: '100%', /*minRows: 3, maxRows: 11, */
            columns: _columns,
            // buttons: [
            //     { _button: '添加...', /* icon: 'plus', */  handler: this.handleAddProcessFormItem, },
            // ],
            // onDoubleTap: data => {
            //     Tyan.pubForm.showDialog('流程状态设置', props => <ProcessFormItemDiv {...props} id={data.id} ProcessID={id} onRefresh={() => this.doGetProcess(id)} />)
            // },
        }
    }

    // fieldset流程状态 = () => {
    //     const { id } = this.state
    //     return [{
    //         _grid: '', name: '流程状态', rowNumbers: true, /*minRows: 3, maxRows: 11, */ height: '100%',
    //         columns: [
    //             { _text: '状态名称', flex: 2 },
    //             { _text: '执行人', flex: 3 },
    //             { _text: '执行部门', flex: 3 },
    //         ],
    //         buttons: [
    //             { _button: '添加...', /* icon: 'plus', */  handler: this.handleAddProcessStatus, },
    //         ],
    //         onDoubleTap: data => {
    //             Tyan.pubForm.showDialog('流程状态设置', props => <ProcessStatusDiv {...props} id={data.id} ProcessID={id} onRefresh={() => this.doGetProcess(id)} />)
    //         },
    //     }]
    // }

    render() {
        const { showMessage: Message, showBody: Body } = this.props
        const { errorMessage, id, initValues基本信息, changedValues基本信息 } = this.state
        if (errorMessage) return Tyan.pubForm.showError(errorMessage)
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        console.log('values', values)
        var buttons = []
        if (initValues基本信息.流程操作) {
            console.log('initValues基本信息.流程操作', initValues基本信息.流程操作)
            initValues基本信息.流程操作.forEach(o => {
                console.log('o.操作名称', o.操作名称)
                buttons.push({ _button: o.操作名称, icon: 'share', handler: this.handlerFlow(o.操作名称), disabled: this.bSave() })
            });
        }
        buttons.push({ _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !this.bSave(), })
        buttons.push({ _button: '删除', icon: 'trash-o', ui: 'action decline alt', cdt: () => id > 0, handler: this.handlerDelete })
        buttons.push({ _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose })
        return <Body data={this} maxWidth="1100"
            controls={buttons}
            fieldsets={
                [
                    { title: values.流程名称, name: '基本信息', _fieldset: this.fieldset基本信息(), docked: 'top', height: '100%', },
                ]
            }
        />
    }
}

export default connect()(ProcessDetail)